import React, {useState, useRef} from "react";
import logo from "../assets/logo.png";
import "./layout.scss";
import {FiSearch, FiX} from "react-icons/fi";

const Header = ({onSearch}) => {
    const [term, setTerm] = useState("");
    const [searchOpen, setSearchOpen] = useState(false);
    const inputRef = useRef(null);

    const handleSubmit = () => {
        if (onSearch) {
            onSearch(term.trim());
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            handleSubmit();
        }
    };

    const handleToggleSearch = () => {
        setSearchOpen((prev) => {
            const next = !prev;
            if (!prev) {
                setTimeout(() => {
                    if (inputRef.current) {
                        inputRef.current.focus();
                    }
                }, 0);
            }
            return next;
        });
    };

    return (
        <header className="site-header">
            <div className={`header-inner container ${searchOpen ? "search-open" : ""}`}>
                <div className="header-brand">
                    <a href="/" className="header-logo">
                        <img src={logo} alt="career logo"/>
                    </a>
                </div>
                <div className={`header-search ${searchOpen ? "open" : ""}`}>
                    <button
                        type="button"
                        className="header-search-toggle"
                        onClick={handleToggleSearch}
                    >
                        <FiSearch/>
                    </button>
                    <button
                        type="button"
                        className="header-search-close"
                        onClick={() => setSearchOpen(false)}
                        aria-label="Close search"
                    >
                        <FiX/>
                    </button>
                    <input
                        type="text"
                        className="header-search-input"
                        placeholder="Job title or keyword (eg, accountant, assistant)"
                        value={term}
                        onChange={(event) => setTerm(event.target.value)}
                        onKeyDown={handleKeyDown}
                        ref={inputRef}
                    />
                    <button
                        type="button"
                        className="header-search-button"
                        onClick={handleSubmit}
                    >
                        <FiSearch/>
                    </button>
                </div>
            </div>
        </header>
    );
};

export default Header;
